module.exports = __webpack_public_path__ + "static/media/charity.cfe141f5.png";